import HeroSection from "./heroSection/heroSection.component";
import FeatureSection from "./featureSection/featureSection.component";
import MetricsSection from "./metricsSection/metricsSection.component";
import Testimonials from "./testimonials/testimonials.component";
import PrimaryCTA from "./primaryCta/primaryCta.component";
import SecondaryCTA from "./secondaryCta/secondaryCta.component";
import EventsSection from "./eventsSection/eventsSection.component";
import IndustriesSection from "./industriesSection/industriesSection.component";
import ComparisonSection from "./comparisonSection/comparisonSection.component";
import ProblemSection from "./problemSection/problemSection.component";

export {
    FeatureSection,
    MetricsSection,
    Testimonials,
    SecondaryCTA,
    EventsSection,
    IndustriesSection,
    ComparisonSection,
    PrimaryCTA,
    HeroSection,
    ProblemSection,
};
